export default "__VITE_ASSET__3e006a8c__"